import { useState, useEffect } from 'react';
import { Card, Chip, Typography, TextField, Grid, Button, Box, Tooltip, IconButton, Modal, InputAdornment, Skeleton, Switch, useTheme, useMediaQuery, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Swal from 'sweetalert2';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { DataGrid, } from '@mui/x-data-grid';
import { useForm, Controller } from 'react-hook-form';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import { CrudServices } from './CrudServices';
import NoRowsLayout from '../../components/Layout/NoRowsLayout';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Helpers } from '../../services/Helpers';
import { PermissionGuard } from '../../components/PermissionGuard';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import { Search } from '@mui/icons-material';
import Loading from '../../components/Loader/Loading';
import ExportAll from './filterAndExport/ExportAll';
import QuickSearchTool from '../../components/QuickSearch/QuickSearchTool';
import Filter from './filterAndExport/Filter';
import { LocalStore } from '../../storage/authStore';
import SacCodeManagement from './SacCodeManagement';
import { current } from '@reduxjs/toolkit';
import noImage from '../../assets/images/no_image_available.png'

export default function ServiceList() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const loggedUser = LocalStore.getLoggedUserDetails();
  console.log('loggedUser', loggedUser);
  const navigate = useNavigate();
  const { control, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      searchKey: "",
    }
  });

  const [allRowCount, setAllRowCount] = useState(0);
  const [list, setList] = useState([]);
  const [deleteRowData, setDeleteRowData] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
    filters: {
      searchKey: "",
      sortBy: 'createdAt',
      sortType: 'desc',
      filterOptions: []
    }
  });

  const [loading, setLoading] = useState(false);

  const fetchServiceList = async () => {
    try {
      setLoading(true)
      const listResponse = await CrudServices.allServices({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,   // Use the title filter from the paginationModel
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });
      // console.log("Service list Response:",listResponse)
      // setValue('status', paginationModel.filters.status)
      if (listResponse.success == '1') {
        console.log("Service list length:", listResponse.data.list.length)
        setList(listResponse.data.list);
        setAllRowCount(listResponse.data.totalItems);
      }
      else {
        //   Swal.fire('Request failed','','error')
      }
    } catch (error) {
      Swal.fire(error.message, '', 'error')
    }
    setLoading(false)
  };

  /************************  Manage Use Effect **************************** */
  useEffect(() => {
    fetchServiceList();
  }, [paginationModel, deleteRowData]);
  const [sacList, setSacList] = useState([]);
  const fetchSacList = async () => {
    try {
      const response = await CrudServices.fetchSacCodes();
      console.log("response", response);
      if (response.success == '1') {
        setSacList(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    fetchSacList()
  }, [])

  const handleStatusChange = async (id, currentStatus) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `You want to change the status form ${currentStatus ? 'Active' : 'In-Active'} to ${currentStatus ? 'In-Active' : 'Active'} of this service!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, change it!',
      cancelButtonText: 'No, keep it'
    });
    if (result.isConfirmed) {
      // processing screen 
      Swal.fire({
        title: 'Processing',
        html: 'Please wait...',
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        const response = await CrudServices.changeServiceStatus(id);
        if (response.success == '1') {
          Swal.fire('Status Changed!', '', 'success');
          setDeleteRowData(response.data);
        } else {
          Swal.fire('Failed!', '', 'error');
        }
      } catch (error) {
        Swal.fire('Failed!', '', 'error');
      }
    }
  }

  
  /************************  Table Column Manage **************************** */
  const columns = [
    {
      field: 'title',
      headerName: 'Service',
      headerAlign: 'center',
      flex: 2,
      // filterable: false,
      valueGetter: (params) => {
        // Join all subcategory titles into a single searchable string
        const parentServiceTitle = params.row.parentServiceId > 0 && params.row.parentService?.title || '';
        const title = params.row.title;
        return parentServiceTitle ? `${title} (${parentServiceTitle})` : title;
      },
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <Box sx={{ width: '15%' }}>
            {params.row.images ? (
              <img
                //   src={params.row.images} 
                src={`${Helpers.ImagePathUrl()}/service/sm/${params.row.images}`}
                alt={params.row.title}
                style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
              />
            ) : (
              // <Skeleton variant="rectangular" width={35} height={35} animation={false} />
              <img
                //   src={params.row.images} 
                src={noImage}
                alt={params.row.title+'image_not_available'}
                style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
              />
            )}
          </Box>
          <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} sx={{ ml: 1, width: '85%' }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#3e3e3e', textAlign: 'center', fontSize: '.7rem' }}>{params.row.title}
              {(loggedUser?.role.title == 'Admin' || loggedUser?.role.title == 'Super Admin') &&
                <Box component={'span'} sx={{ fontSize: '.6rem', fontWeight: 500, color: '#1976d2' }}>
                  {`(${params.row.id})`}
                </Box>
              }
            </Typography>
            {params.row.parentServiceId > 0 && <Typography variant="caption" sx={{ justifyContent: 'center', alignItems: 'center', fontSize: '.5rem' }}>{`(${params.row.parentService?.title || ''})`}</Typography>}
          </Box>
        </Box>
      ),
    },
    {
      field: 'category',
      headerName: 'Category Detail',
      headerAlign: 'center',
      flex: 2,
      sortable: false,
      valueGetter: (params) => {
        // Join all subcategory titles into a single searchable string
        const categoryTitle = params.row.ServiceCategoryRels[0]?.ServiceCategory?.parentCategory.title;
        const subCategoryTitle = params.row.ServiceCategoryRels[0]?.ServiceCategory?.title;
        return categoryTitle ? `${subCategoryTitle} (${categoryTitle})` : subCategoryTitle;
      },
      renderCell: (params) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row.ServiceCategoryRels[0]?.ServiceCategory?.title}</Typography>
          <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>{`( ${params.row.ServiceCategoryRels[0]?.ServiceCategory?.parentCategory.title} )`}</Typography>
        </Box>
      ),
    },

    {
      field: 'Count Details',
      headerName: 'countDetails',
      headerAlign: 'center',
      flex: 2,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1, width: "100%" }}>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Typography sx={{ width: '85%', fontWeight: 500, color: '#3e3e3e', fontSize: '0.65rem', }}>Associated Experts</Typography>
            <Typography sx={{ width: '2%', fontWeight: 500, color: '#3e3e3e', fontSize: '0.65rem', }}>:</Typography>
            {params?.row?.providersInfo?.count>0 ?
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        padding: '0',
                        // bgcolor: 'transparent',  // if you also want to remove background
                        maxHeight:'20rem',
                        width:'max-content',
                        overflow:'auto'
                      }
                    }
                  }}
                  title={
                    <Paper sx={{ p: .5,bgcolor:'lightGray' }}>
                      {params?.row?.providersInfo?.rows.map((expert, index) => (
                        <Card key={index} sx={{mb:'2%',p:1}}>
                          <Typography variant="caption" sx={{whiteSpace: 'wrap' }}>
                            <Box component='span' sx={{color:'#1976d2',cursor:'pointer'}} onClick={()=>window.open(`/admin/expert-detail/${expert?.userId}`,'_blank')}>{expert?.userId}</Box>_{expert?.User?.UserProfile?.firstName || ''} {expert?.User?.UserProfile?.middleName || ''} {expert?.User?.UserProfile?.lastName || ''}, {expert?.User?.mobileNumber}
                          </Typography>
                        </Card>
                      ))}
                    </Paper>
                  }
                  placement="bottom-start"  // You can change this to any valid placement
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -10], // Horizontal and vertical offset
                        },
                      },
                    ],
                  }}
                  enterDelay={200}
                  leaveDelay={200}
                >
                  <Typography sx={{ width: '13%', fontWeight: 400, color: params.row?.providersInfo?.count>0?'#1976d2':'#3e3e3e', fontSize: '0.65rem',cursor:params?.row?.providersInfo?.count>0 ? 'pointer' : 'default' }}>{params.row.providersInfo.count || 0}</Typography>    
                </Tooltip>
              :
              <Typography sx={{ width: '13%', fontWeight: 400, color: params.row?.providersInfo?.count>0?'#1976d2':'#3e3e3e', fontSize: '0.65rem',cursor:params?.row?.providersInfo?.count>0 ? 'pointer' : 'default' }}>{params.row.providersInfo.count || 0}</Typography> 
            }
          </Box>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Typography sx={{ width: '85%', fontWeight: 500, color: '#3e3e3e', fontSize: '0.65rem', }}>Associated Bookings</Typography>
            <Typography sx={{ width: '2%', fontWeight: 500, color: '#3e3e3e', fontSize: '0.65rem', }}>:</Typography>
            {params?.row?.bookingsInfo?.count>0 ?
                <Tooltip
                  componentsProps={{
                    tooltip: {
                      sx: {
                        padding: '0',
                        // bgcolor: 'transparent',  // if you also want to remove background
                        maxHeight:'20rem',
                        width:'max-content',
                        overflow:'auto'
                      }
                    }
                  }}
                  title={
                    <Paper sx={{ p: .5,bgcolor:'lightGray' }}>
                      {params?.row?.bookingsInfo?.rows.map((booking, index) => (
                        <Card key={index} sx={{mb:'2%',p:.5}}>
                          <Typography variant="caption" sx={{whiteSpace: 'wrap',color:'#1976d2',cursor:'pointer' }} onClick={()=>window.open(`/admin/booking-details/${booking.serviceBookingId}`,'_blank')}>
                            {booking?.serviceBooking?.bookingNumber}
                          </Typography>
                        </Card>
                      ))}
                    </Paper>
                  }
                  placement="bottom-start"  // You can change this to any valid placement
                  PopperProps={{
                    modifiers: [
                      {
                        name: 'offset',
                        options: {
                          offset: [0, -10], // Horizontal and vertical offset
                        },
                      },
                    ],
                  }}
                  enterDelay={200}
                  leaveDelay={200}
                >
                  <Typography sx={{ width: '13%', fontWeight: 400, color: params.row?.bookingsInfo?.count>0?'#1976d2':'#3e3e3e', fontSize: '0.65rem',cursor:params?.row?.bookingsInfo?.count>0 ? 'pointer' : 'default' }}>{params.row.bookingsInfo.count || 0}</Typography>    
                </Tooltip>
              :
              <Typography sx={{ width: '13%', fontWeight: 400, color: params.row?.bookingsInfo?.count>0?'#1976d2':'#3e3e3e', fontSize: '0.65rem',cursor:params?.row?.bookingsInfo?.count>0 ? 'pointer' : 'default' }}>{params.row.bookingsInfo.count || 0}</Typography> 
            }
          </Box>
        </Box>
      ),
    },
    {
      field: 'sac',
      headerName: 'SAC Code',
      headerAlign: 'center',
      flex: 1.5,
      sortable: false,
      valueGetter: (params) => {
        const sacCode = params.row.sacId && sacList.find(sac => sac.id == params.row.sacId)?.sac || '';
        return sacCode;
      },
      renderCell: (params) => (
        <SacCodeManagement serviceData={params.row} sacList={sacList} />
      )
    },
    {
      field: 'status',
      headerName: 'Status',
      headerAlign: 'center',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Switch
            size='small'
            checked={params.row.isActive}
            onChange={() => handleStatusChange(params.row.id, params.row.isActive)}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: 'success.main',
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: 'success.main'
              },
              '& .MuiSwitch-switchBase': {
                color: 'error.main',
              },
              '& .MuiSwitch-track': {
                backgroundColor: 'error.main'
              }
            }}
            inputProps={{ 'aria-label': 'controlled' }}
          />
          <Chip
            label={params.row.isActive ? 'Active' : 'Inactive'}
            color={params.row.isActive ? 'success' : 'error'}
            size="small"
            sx={{ fontSize: '0.65rem', height: 'fit-content' }}
          />
        </Box>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign: 'center',
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1, display: 'flex', gap: 1, justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <IconButton
            sx={{ color: "blue", }}
            // onClick={() => modalOpen(params.row,'view')} 
            onClick={(e) => window.open(`/admin/service-details/${params.row.id}`, '_blank')}
            size="small">
            <RemoveRedEyeIcon sx={{ fontSize: '0.95rem' }} />
          </IconButton>
          <PermissionGuard feature='service' permission='canEdit'>
            <IconButton
              // onClick={() => modalOpen(params.row,'edit')} 
              onClick={(e) => window.open(`/admin/service/${params.row.id}`, '_blank')}
              size="small" color='warning'
            >
              <EditIcon sx={{ fontSize: '0.95rem' }} />
            </IconButton>
          </PermissionGuard>
          {/* <IconButton onClick={() => deleteService(params.row.id)} size="small">
              <DeleteIcon />
            </IconButton> */}
        </Box>
      ),
    },
  ];
  /************************  Action Handler Related table row **************************** */
  const handlePaginationChange = (newPagination) => {
    setPaginationModel({
      ...paginationModel,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    });
  }

  function onSubmit(data) {
    const filtersData = getValues();
    setPaginationModel({
      ...paginationModel,
      filters: {
        ...paginationModel.filters,
        searchKey: filtersData.searchKey,
      }
    });
  }

  const clearFilters = () => {
    reset({
      searchKey: "",
    });
    setPaginationModel({
      ...paginationModel,
      filters: {
        ...paginationModel.filters,
        searchKey: "",
        sortBy: 'createdAt',
        sortType: 'desc',
        filterOptions: []
      }
    });

    // Trigger clear for MultiColumnFilter
    setClearMultiFilter(true);

    // Reset the clear trigger after a short delay
    setTimeout(() => setClearMultiFilter(false), 100);
  }

  /************************  Advance Filter **************************** */


  const [clearMultiFilter, setClearMultiFilter] = useState(false);

  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
        filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }

  /************* quick search related **************/
  // Properly structured filter model
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: []
  });

  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortBy,
      sort: paginationModel.filters.sortType,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortBy: newSortModel[0].field,
          sortType: newSortModel[0].sort
        }
      }));
    }
  }

  return (
    <>
      <PageHeaderLayout headerTitle={'Manage Master Services'}>
        <PermissionGuard feature='service' permission='canCreate'>
          <Button variant='contained' size='small'
            // onClick={() => modalOpen({},'add')} 
            onClick={() => navigate('/admin/service/0')}
            sx={{ fontSize: { xs: '.5rem', sm: '.75rem' } }} endIcon={<AddCircleIcon />}
          >
            Add Service
          </Button>
        </PermissionGuard>
      </PageHeaderLayout>
      {/* =================== Searching and sorting section ================== */}
      <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={1} sx={{ p: '1%' }}>
            <Grid item xs={9} sm={5} md={4} lg={3}>
              <Controller
                name="searchKey"
                control={control}
                // defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    placeholder="Search here....."
                    // label="Search"
                    size="small"
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        paddingLeft: '0px',
                      }
                    }}
                    InputProps={{  // Changed from slotProps to InputProps
                      inputProps: {
                        style: {
                          height: '0.6rem',
                          textTransform: 'uppercase',
                          fontSize: 'x-small'
                        },
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton>
                            <Search sx={{ fontSize: 'x-small' }} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3} sm={2} >
              <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                <IconButton
                  size='small'
                  color="primary"
                  type="submit"
                  sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                >
                  <SearchIcon sx={{ fontSize: '.85rem' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear All Filters">
                <IconButton
                  size='small'
                  color="primary"
                  sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                  onClick={clearFilters}
                >
                  <RestartAltIcon sx={{ fontSize: '.85rem' }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </form>
      </Card>

      <Box sx={{ overflow: "auto" }}>
        {loading && <Loading />}
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Filter
                onApplyFilter={handleApplyFilter}
                externalClear={clearMultiFilter}
              />
              <ExportAll paginationModel={paginationModel} />
            </Box>
            <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} />
          </Box>
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: col.flex || 1, // Ensure columns resize dynamically
              minWidth: isSmallScreen && (col.minWidth || 150), // Set a minimum width to avoid overlap
            }))}
            getRowId={(row) => row.id}
            //checkboxSelection={true}
            rowCount={allRowCount}  // Use the length of the filtered list
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}

            filterModel={filterModel}

            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortingChange}

            loading={loading}

            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              // toolbar: GridToolbar,                        
              loadingOverlay: Loading,
              noRowsOverlay: NoRowsLayout,
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
              '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
              },
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                borderTop: '2px solid rgba(224, 224, 224, 1)',
                fontWeight: 600,
                fontSize: '0.75rem',
                p: 0,
                height: 'fit-content',
                minHeight: '0 !important',
                height: '2rem'
              },
              '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
              },
              '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
          />
        </Box>
      </Box>
    </>
  )
}